import Box from '@mui/material/Box';
import { DEFAULT_CHECKED_TITLES, SwitchBox } from '../SwitchBox';
import { FilterDropdown } from './FilterDropdown';
import { FilterDropdownSlider } from './FilterDropdownSlider';

type Marks = { value: number; label: string; scaledValue: number }[];

export type Filter = {
  values: string[];
  enabled: boolean;
  type?: 'switch' | 'checkbox' | 'slider';
  title?: string;
  labels?: string[];
  withSearch?: boolean;
  variant?: 'default' | 'skins';
  formatSymbol?: string;
  marks?: Marks;
};

type CatalogueFilterProps = {
  filter: Filter;
  handleFilterChange: (title: string, filter: Filter) => void;
  cleared: boolean;
  filterFromQuery?: Filter;
};

export const CatalogueFilter = ({
  filter,
  handleFilterChange,
  cleared,
  filterFromQuery,
}: CatalogueFilterProps) => {
  switch (filter.type) {
    case 'switch':
      return (
        <Box sx={{ mb: 4, pl: 6, pr: 4 }}>
          <SwitchBox
            filterFromQuery={filterFromQuery}
            title={filter.title as string}
            handleFilterChange={handleFilterChange}
            cleared={cleared}
            defaultChecked={DEFAULT_CHECKED_TITLES.includes(
              filter?.title || '',
            )}
          />
        </Box>
      );
    case 'slider':
      return (
        <Box sx={{ mb: 6, pl: 6, pr: 4 }}>
          <FilterDropdownSlider
            filterFromQuery={filterFromQuery}
            title={filter.title as string}
            handleFilterChange={handleFilterChange}
            cleared={cleared}
            formatSymbol={filter.formatSymbol as string}
            marks={filter.marks as Marks}
          />
        </Box>
      );
    case 'checkbox':
      return (
        <Box sx={{ mb: 6, pl: 6, pr: 4 }}>
          <FilterDropdown
            filterFromQuery={filterFromQuery}
            title={filter.title as string}
            handleFilterChange={handleFilterChange}
            cleared={cleared}
            filterOptions={filter.labels as string[]}
            withSearch={filter?.withSearch}
            variant={filter?.variant}
          />
        </Box>
      );
    default:
      return null;
  }
};
